import { render, staticRenderFns } from "./AddToCardBox.vue?vue&type=template&id=ddfa4188&scoped=true&"
import script from "./AddToCardBox.vue?vue&type=script&lang=js&"
export * from "./AddToCardBox.vue?vue&type=script&lang=js&"
import style0 from "./AddToCardBox.vue?vue&type=style&index=0&id=ddfa4188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfa4188",
  null
  
)

export default component.exports